import {useDispatch, useSelector} from "react-redux";
import {setLoader} from "../../../Store/Slice/techsbookSlice";
import {useLazyGetAllTechniciansLocationsQuery, useLazyGetTechniciansQuery} from "../../../Store/Builder/dashboard.api";
import showToast from "../../Hooks/toast";
import {setAllTechsLocs, setTechniciansList} from "../../../Store/Slice/dashboardSlice";
import {useEffect} from "react";

const useGetTechnicians = (page) => {
    const dispatch = useDispatch();
    const [getTechnicians] = useLazyGetTechniciansQuery();
    const [getAllTechniciansLocations] = useLazyGetAllTechniciansLocationsQuery();

    const { certificate, address, addressTech, coordinates } = useSelector((state) => state.rootReducer.dashboardSlice)
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );

    const formatParams = () => {
        const certificateParams = `certificate_id=${certificate?.id}`;
        const lat = `${coordinates ? '&' : ''}lat=${coordinates?.lat}`
        const lon = `${coordinates ? '&' : ''}lon=${coordinates?.lon}`
        const pageParam = `&page=${page}`;
        return `${certificate ? certificateParams : ''}${pageParam ? pageParam : ''}${lat && (address?.address || address?.length) ? lat : ''}${lon && (address?.address || address?.length) ? lon : ''}`;
    }

    const get = () => {
        dispatch(setLoader(true));
        const formattedParams = formatParams();
        getTechnicians(formattedParams)
          .unwrap()
          .then((res) => {
              dispatch(setLoader(false));
              dispatch(setTechniciansList(res));
          })
          .catch((err) => {
              dispatch(setLoader(false));
              showToast(err?.data?.message ?? "Error", "error");
          });
    };
    const getAllTechsLocs = () => {
        dispatch(setLoader(true));
        getAllTechniciansLocations()
          .unwrap()
          .then((res) => {
              dispatch(setLoader(false));
              dispatch(setAllTechsLocs(res));
          })
          .catch((err) => {
              dispatch(setLoader(false));
              showToast(err?.data?.message ?? "Error", "error");
          });
    };

    useEffect(() => {
      if (accountIndex?.registration_completed) {
        get()
      }
    }, [certificate, address, page, accountIndex, coordinates])

    return {
        get,
        getAllTechsLocs,
    };
};

export default useGetTechnicians;
